export const HEADER_TYPES = {
  BOOKING: 'booking',
  DEFAULT: 'default',
};
